import { render, staticRenderFns } from "./NumberWidget.vue?vue&type=template&id=0dc457a0&"
import script from "./NumberWidget.vue?vue&type=script&lang=js&"
export * from "./NumberWidget.vue?vue&type=script&lang=js&"
import style0 from "./NumberWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports